<template>
<v-container fluid grid-list-lg style="min-height:100%">

  <span class="centerized title grey--text text-xs-center" v-if="!loading && allContacts.length===0">{{ $t('contact.no_contact_available_hint') }}</span>

  <v-layout row wrap v-else-if="!loading">
    <v-flex xl2 lg3 md4 sm6 xs12 v-for="c in allContacts" :key="c.key">
      <contact-item :contact="c" @click="editContact"></contact-item>
    </v-flex>
  </v-layout>

  <contact-editor-dialog v-if="dialogEditor" v-model="dialogEditor" :contact="dialogContact" @toast="val=>$emit('toast',val)"></contact-editor-dialog>

  <v-btn color="secondary" dark fixed bottom right fab v-if="!loading" @click="addContact">
    <v-icon>add</v-icon>
  </v-btn>

  <progress-dialog :visible="loading">{{ $t('loading') }}</progress-dialog>

</v-container>
</template>

<script>
import UserAuth from '@/components/auth/UserAuth'
import ContactItem from './ContactItem'
import ContactEditorDialog from './ContactEditorDialog'

export default {
  name: 'Contact',
  mixins: [UserAuth],
  components: {
    'contact-item': ContactItem,
    'contact-editor-dialog': ContactEditorDialog
  },
  data() {
    return {
      dialogContact: null,
      dialogEditor: false,
    }
  },
  computed: {
    loading() {
      return this.contactLoading;
    },
    allContacts() {
      let list = [];
      Object.keys(this.userContact).forEach(key => {
        list.push({
          key: key,
          ...this.userContact[key]
        })
      });
      return list.sort((a, b) => (a.name || '').localeCompare(b.name));
    }
  },
  methods: {
    editContact(c) {
      this.dialogContact = c;
      this.dialogEditor = true;
    },
    addContact() {
      this.dialogContact = null;
      this.dialogEditor = true;
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contact/Contact.vue